import identity from "lodash/fp/identity";
class AuthorizationPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default AuthorizationPageTransform;



// WEBPACK FOOTER //
// ./src/pages/authorization/authorization.transforms.js